import { Container, Nav, Navbar } from 'react-bootstrap';

const NavbarTop = () => {
  return (
    <Navbar expand="sm" className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="#home">
          <img
            src={`${process.env.PUBLIC_URL}/img/steering-wheel.png`}
            alt="logo"
            width="25px"
            style={{ marginRight: '10px' }}
          />
          Habilite-se
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#home">Home</Nav.Link>
            <Nav.Link href="#link">Link</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export { NavbarTop };
